module.exports = __webpack_public_path__ + "static/media/verifica-prezenta.83fd1a5d.svg";